import { BalancingGroupObject, BalancingObject } from './balancingLib';

export enum BalancingGroupVUnknown {}

export const balancingGroupVUnknown: Record<BalancingGroupVUnknown, BalancingGroupObject> =
  {} as const;

export const emptyBalancingObjectVUnknown: BalancingObject = {};
